<div class="modal-header pt-4 px-2 px-md-4">
  <h5 class="modal-title">Filtro</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="close()"></button>
</div>
<div class="modal-body px-2 px-md-4">
  <div class="col-12 field mb-3" *ngFor="let filter of getOptions();let i = index">
    <span>{{ filter.title }}</span>
    <div class="col-12 form-group" *ngIf="filter.format == 'currency'">
      <input currencyMask class="form-control" type="text" [(ngModel)]="filter.model">
    </div>
    <div class="col-12 form-group" *ngIf="filter.format == 'numeric'">
      <input OnlyNumber class="form-control" type="text" [(ngModel)]="filter.model">
    </div>
    <div class="col-12 form-group" *ngIf="filter.format == 'text'">
      <input class="form-control" type="text" [(ngModel)]="filter.model">
    </div>
    <div class="col-12" *ngIf="filter.format == 'button_date'">
      <div class="d-block d-lg-flex gap-1 text-center mx-lg-n2" role="group" aria-label="Toggle group">
        <ng-container *ngFor="let item of filter.items; let c = index">
          <input type="radio" class="btn-check" name="button_date" id="option_{{c}}" autocomplete="off"
            [(ngModel)]="filter.model.value" [value]="item.value" (click)="filter.model = item;clearRange()">
          <label class="btn btn-outline-secondary py-2 mb-2" for="option_{{c}}">{{item.label}}</label>
        </ng-container>
      </div>
    </div>
    <div class="col-12" *ngIf="filter.format == 'single'">
      <select class="form-select" [ngModel]="filter.model.value" (change)="onChange(filter, $event)">
        <option *ngFor="let item of filter.items" [value]="item.value">
          {{item.label}}
        </option>
      </select>
    </div>
    <div class="col-12" *ngIf="filter.format == 'tags'">
      <tag-input [(ngModel)]="filter.model" [identifyBy]="'value'" [displayBy]="'label'" [onlyFromAutocomplete]="true"
        [placeholder]="filter.secondary_placeholder" [secondaryPlaceholder]="filter.placeholder"
        [onAdding]="verifyExclusive">
        <tag-input-dropdown [showDropdownIfEmpty]="true" [appendToBody]="false" [displayBy]="'label'"
          [identifyBy]="'value'" [autocompleteItems]="filter.items" zIndex="10000" [dynamicUpdate]="false">
          <ng-template let-item="item" let-index="index">
            {{ item.label }}
          </ng-template>
        </tag-input-dropdown>
      </tag-input>
    </div>
    <div class="col-12" *ngIf="filter.format === 'date'">
      <input type="text" Mask="##/##/####" [minDate]="getMinDate(filter)"
        [bsConfig]="{containerClass:'theme-default', adaptivePosition: true}" bsDatepicker class="form-control"
        [(ngModel)]="filter.model" [ngModelOptions]="{standalone: true}">
    </div>
    <div class="col-12" *ngIf="filter.format === 'date_range'">
      <div class="input-group">
        <input type="text" Mask="##/##/#### - ##/##/####" placeholder="DD/MM/YYYY - DD/MM/YYYY" class="form-control"
          [(ngModel)]="filter.model" [bsConfig]="{containerClass:'theme-default', adaptivePosition: true}"
          bsDaterangepicker readonly>
        <span class="input-group-text py-0" (click)="clearRange()" role="button">
          <em class="bi bi-eraser-fill fs-5 text-primary"></em>
        </span>
      </div>
    </div>
    <div class="col-12" *ngIf="filter.format === 'auto-complete'">
      <div class="input-group">
        <input type="text" class="form-control" [placeholder]="filter.placeholder" [(ngModel)]="filter.model.label"
          (input)="filterAutoComplete(filter.type, filter.model.label)" (blur)="onBlurAutoComplete(filter)"
          autocomplete="off">
        <span class="input-group-text py-0" (click)="clearAutoComplete(filter)" role="button">
          <em class="bi bi-eraser-fill fs-5 text-primary"></em>
        </span>
      </div>
      <ul class="list-group position-absolute w-100 overflow-auto" [style.max-height.%]="60"
        *ngIf="listAutoComplete?.length">
        <li class="list-group-item list-group-item-action" *ngFor="let item of listAutoComplete"
          (click)="selectAutoComplete(filter, item)">
          {{item.label}}
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="modal-footer border-0 d-flex justify-content-center my-2">
  <button class="mt-3 mt-md-0 btn btn-primary px-5 py-2" (click)="search()">CONFIRMAR</button>
</div>